// extracted by mini-css-extract-plugin
export default {"selectWrapper":"style_selectWrapper__-oB-C","select":"style_select__G4bkC","icon":"style_icon__SeCYA"};